import React, { useState } from "react";
import "./PaymentStep.css";

const PaymentStep = ({ formData, onPaymentCreate, onSimulatePayment, paymentReference, loading }) => {
  const [processingPayment, setProcessingPayment] = useState(false);
  const [simulatingPayment, setSimulatingPayment] = useState(false);

  const handleCreatePaymentLink = async () => {
    setProcessingPayment(true);
    try {
      await onPaymentCreate();
    } catch (error) {
      console.error("Error creando enlace de pago:", error);
    } finally {
      setProcessingPayment(false);
    }
  };

  const handleSimulatePayment = async () => {
    setSimulatingPayment(true);
    try {
      await onSimulatePayment();
    } catch (error) {
      console.error("Error simulando pago:", error);
    } finally {
      setSimulatingPayment(false);
    }
  };

  return (
    <div className="payment-step">
      <div className="payment-header">
        <div className="payment-icon">💳</div>
        <h2>Paso 3: Realizar Pago</h2>
        <p className="payment-subtitle">
          Completa tu suscripción mensual de $39 USD
        </p>
      </div>

      <div className="payment-summary-card">
        <h3>📋 Resumen de Suscripción</h3>

        <div className="summary-section">
          <div className="summary-label">Negocio:</div>
          <div className="summary-value">{formData.businessName}</div>
        </div>

        <div className="summary-section">
          <div className="summary-label">Contacto:</div>
          <div className="summary-value">{formData.contactName}</div>
        </div>

        <div className="summary-section">
          <div className="summary-label">Email:</div>
          <div className="summary-value">{formData.email}</div>
        </div>

        <div className="summary-section">
          <div className="summary-label">Teléfono:</div>
          <div className="summary-value">{formData.phoneNumber}</div>
        </div>

        <div className="summary-section">
          <div className="summary-label">Sitio Web:</div>
          <div className="summary-value">{formData.businessWebsite}</div>
        </div>

        <div className="summary-divider"></div>

        <div className="summary-section highlight">
          <div className="summary-label">Plan:</div>
          <div className="summary-value">Suscripción Mensual</div>
        </div>

        <div className="summary-section highlight">
          <div className="summary-label">Tipo de Voz:</div>
          <div className="summary-value">
            {formData.botCustomization?.voiceType === "female"
              ? "🗣️ Voz Femenina"
              : "🗣️ Voz Masculina"}
          </div>
        </div>
      </div>

      <div className="payment-amount-card">
        <div className="amount-label">Total a Pagar</div>
        <div className="amount-value">$39.00</div>
        <div className="amount-period">USD / mes</div>
        <div className="amount-note">
          ✓ Incluye agente de voz IA personalizado<br/>
          ✓ Base de conocimiento automática<br/>
          ✓ Integración con ElevenLabs<br/>
          ✓ Soporte técnico
        </div>
      </div>

      <div className="payment-info-card">
        <div className="info-icon">ℹ️</div>
        <div className="info-content">
          <h4>Proceso de Pago Seguro</h4>
          <p>
            Al hacer clic en "Proceder al Pago", serás redirigido a Wompi,
            nuestra pasarela de pago segura. Allí podrás completar tu pago
            con tarjeta de crédito o débito.
          </p>
          <p className="info-highlight">
            ✓ Pago 100% seguro y encriptado<br/>
            ✓ Tu agente se creará automáticamente después del pago
          </p>
        </div>
      </div>

      <div className="payment-actions">
        <button
          type="button"
          onClick={handleCreatePaymentLink}
          disabled={processingPayment || loading}
          className="payment-btn-primary"
        >
          {processingPayment || loading ? (
            <>
              <span className="spinner-small"></span>
              Generando enlace de pago...
            </>
          ) : (
            <>
              <span className="payment-icon-btn">💳</span>
              Proceder al Pago
            </>
          )}
        </button>

        {/* Botón de simulación - Solo para desarrollo */}
        {paymentReference && (
          <button
            type="button"
            onClick={handleSimulatePayment}
            disabled={simulatingPayment || loading}
            className="payment-btn-simulate"
            style={{
              marginTop: '15px',
              background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
              border: '2px solid #fbbf24'
            }}
          >
            {simulatingPayment ? (
              <>
                <span className="spinner-small"></span>
                Simulando pago...
              </>
            ) : (
              <>
                <span className="payment-icon-btn">🧪</span>
                Simular Pago Exitoso (Desarrollo)
              </>
            )}
          </button>
        )}

        <div className="payment-security-badges">
          <div className="security-badge">
            <span className="badge-icon">🔒</span>
            <span className="badge-text">Pago Seguro</span>
          </div>
          <div className="security-badge">
            <span className="badge-icon">✓</span>
            <span className="badge-text">SSL Encriptado</span>
          </div>
          <div className="security-badge">
            <span className="badge-icon">💯</span>
            <span className="badge-text">100% Confiable</span>
          </div>
        </div>
      </div>

      <div className="payment-footer">
        <p>
          Al proceder con el pago, aceptas nuestros{" "}
          <a href="#terms" className="payment-link">Términos y Condiciones</a>
          {" "}y{" "}
          <a href="#privacy" className="payment-link">Política de Privacidad</a>
        </p>
      </div>
    </div>
  );
};

export default PaymentStep;
